var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.iconOnly)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"title":_vm.title,"variant":_vm.variant},on:{"click":_vm.doSearch}}):_c('b-button',{attrs:{"title":_vm.title,"variant":_vm.variant},on:{"click":_vm.doSearch}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }